import React from "react"
import { graphql } from "gatsby"
import sanitizeHtml from "sanitize-html"
import Counter from "../components/counter"

export const query = graphql`
  fragment TripleFactsFields on DatoCmsTripleFactsComponent {
    componentId: key
    id
    model {
      apiKey
    }
    toggleHeaderAndBlurb
    header
    blurb
    toggleOneDecimalPlace
    title
    showTitle
    facts {
      id
      number
      numberSuffix
      blurbNode {
        childMarkdownRemark {
          html
        }
      }
      label
    }
  }
`

export interface TripleFactsProps extends Queries.TripleFactsFieldsFragment {
  background?: "black" // Add more variants if needed: "black" | "red" | "image"
  spacing?: string
  variant?:
    | "fullwidth"
    | "background-black"
    | "minus"
    | "mobilepadding"
    | "greybackground"
}

const TripleFacts = (props: TripleFactsProps) => {
  const className = `c-triple-facts o-row ${
    props.spacing ? `${props.spacing}` : ""
  } ${props.variant ? `-${props.variant}` : ""} ${
    props.background ? `-fullwidth -background-${props.background}` : ""
  }`

  const showTitle = props.showTitle
  const toggleOneDecimalPlace = props.toggleOneDecimalPlace

  return (
    <section id={props.componentId} className={className}>
      <div className="o-wrapper">
        {props.title && showTitle && (
          <h2 className="c-content-header">{props.title}</h2>
        )}
        <div
          className={`c-triple-facts__content ${
            !props.toggleHeaderAndBlurb ? "full-width" : ""
          }`}
        >
          {props.toggleHeaderAndBlurb && (
            <div className="c-triple-facts__info">
              {props.header && (
                <div className="c-heading--c c-header ">{props.header}</div>
              )}
              {props.blurb && <p className="c-blurb">{props.blurb}</p>}
            </div>
          )}
          <div className="c-triple-facts__items">
            {props.facts.map(item => {
              const label = sanitizeHtml(item.label, {
                allowedTags: ["sup", "sub"],
                allowedAttributes: {},
              })
              const numberSuffix = sanitizeHtml(item.numberSuffix, {
                allowedTags: ["sup", "sub"],
                allowedAttributes: {},
              })
              return (
                <div key={item.id} className="c-triple-facts__item">
                  {label && (
                    <div className="c-triple-facts__item__preamble">
                      <span
                        className="c-label -black"
                        dangerouslySetInnerHTML={{ __html: label }}
                      />
                    </div>
                  )}

                  <div className="c-triple-facts__item__header">
                    <Counter
                      className="count"
                      end={item.number}
                      toggleOneDecimalPlace={toggleOneDecimalPlace}
                    />
                    <label className="c-heading--b">{numberSuffix}</label>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.blurbNode.childMarkdownRemark.html,
                    }}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TripleFacts
